import { call, put, takeEvery, all } from 'redux-saga/effects';
import { fetchPositionsRoutine, fetchPositionCountersRoutine } from '../../routines';
import { getPositions, getPositionCounters } from '../../../../services/positionService';
import { Routine } from 'redux-saga-routines';

function* getPositionsRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getPositions, payload);
    const data = {
      ...response,
      reset: !payload.from
    };

    yield put(fetchPositionsRoutine.success(data));
  } catch {
    yield put(fetchPositionsRoutine.failure());
  }
}

function* getPositionCountersRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getPositionCounters, payload);
    yield put(fetchPositionCountersRoutine.success(response));
  } catch {
    yield put(fetchPositionCountersRoutine.failure());
  }
}

function* watchGetPositionsRequest() {
  yield takeEvery(fetchPositionsRoutine.TRIGGER, getPositionsRequest);
}

function* watchGetPositionCountersRequest() {
  yield takeEvery(fetchPositionCountersRoutine.TRIGGER, getPositionCountersRequest);
}

export default function* positionsSaga() {
  yield all([
    watchGetPositionsRequest(),
    watchGetPositionCountersRequest()
  ]);
}
